import React, { useState, useEffect } from 'react';

import cx from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import dateformat from "dateformat";
import DatePicker from "react-datepicker";
import {
  Button,
  Popover,
  OverlayTrigger,
  FormControl
} from "react-bootstrap";

import "react-datepicker/dist/react-datepicker.css";

import { DATE_RANGES, FOURTEEN_DAYS, CUSTOM } from 'constants/report.jsx';
import { getReportDatesForOption } from 'services/report.service';

import styles from '../report.module.scss';

export function DatePickerView(props) {
  const [reportDate, setReportDate] = useState({
    type: FOURTEEN_DAYS,
    ...getReportDatesForOption(FOURTEEN_DAYS)
  });

  useEffect(() => {
    if (!props.value) {
      return;
    }

    setReportDate((state) => {
      return ({
        ...state,
        type: _.get(props.value, 'type') || FOURTEEN_DAYS,
        startDate: _.get(props.value, 'startDate') || moment(),
        endDate: _.get(props.value, 'endDate') || moment().add(1, 'days')
      })
    });
  }, [props.value]);

  const handleDateRangeClick = (range) => {
    props.onChange({
      type: range.label,
      ...getReportDatesForOption(range.label)
    });

    document.body.click();
  }

  const onStartDateChange = (value) => {
    if (value) {
      const updated = moment(value);
      setReportDate((state) => {
        return ({
          ...state,
          startDate: updated,
          endDate: moment.max(updated, reportDate.endDate)
        })
      });
    }
  };

  const onEndDateChange = (value) => {
    if (value) {
      const updated = moment(value);
      setReportDate((state) => {
        return ({
          ...state,
          startDate: moment.min(updated, reportDate.startDate),
          endDate: updated
        })
      });
    }
  };

  const onSubmit = () => {
    props.onChange({
      type: CUSTOM,
      startDate: reportDate.startDate,
      endDate: reportDate.endDate
    });

    document.body.click();
  }

  const renderLabel = () => {
    const type = _.get(props, 'value.type') || FOURTEEN_DAYS;

    if (type === CUSTOM) {
      const startDate = _.get(props.value, 'startDate') || moment();
      const endDate = _.get(props.value, 'endDate') || moment();

      return `${dateformat(startDate, 'dd mmm yyyy')} - ${dateformat(endDate, 'dd mmm yyyy')}`;
    }

    const option = DATE_RANGES.find(item => item.label === type);
    return option.value;
  }


  return (
    <OverlayTrigger
      trigger="click"
      placement={props.top ? "top-start" : "bottom-start"}
      rootClose
      overlay={
        <Popover id="popover-tools-menu" className={styles.dateSelectionPopover}>
          <Popover.Body>
            <div className={styles.datePickerSegment}>
              <div className={styles.dateSelectionList}>
                {DATE_RANGES.map((range, index) => {
                  return (
                    <div key={index} className={cx(styles.range, {
                      [styles.selectedRange]: range.label === reportDate.type
                    })
                    } onClick={handleDateRangeClick.bind(this, range)}>
                      <i className={cx(styles.icon, 'cleverstory-toggle_on')} />
                      <span className={styles.rangeValue}>{range.value}</span>
                    </div>
                  )
                })}
              </div>
              <div className={styles.customDates}>
                <div className={styles.customDate}>
                  <span className={styles.customDateLabel}>Start Date:</span>
                  <DateInput
                    onChange={onStartDateChange}
                    value={reportDate.startDate.toDate()}
                  />
                </div>

                <div className={styles.customDate}>
                  <span className={styles.customDateLabel}>End  Date:</span>
                  <DateInput
                    onChange={onEndDateChange}
                    value={reportDate.endDate.toDate()}
                  />
                </div>
              </div>

              <div className={styles.submitButton}>
                <Button size='mini' onClick={onSubmit}>Apply</Button>
              </div>
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      <Button variant='light' id="dateFilterButton" className={styles.dateSelectionButton}>
        {renderLabel()}
        <i className={cx('cleverstory-drop-down', styles.dropdownIcon)} />
      </Button>
    </OverlayTrigger>
  )
}

const DateInput = ({ value, onChange }) => {
  return (
    <DatePicker
      customInput={
        <FormControl className={styles.customDateInput} type="text" onSelect={(e) => { e.stopPropagation() }} />
      }
      popperPlacement="right-start"
      dateFormat="dd MMM yyyy"
      showDisabledMonthNavigation
      minDate={moment().subtract(2, "year")}
      maxDate={moment()}
      selected={value}
      onChange={onChange}
    />
  );
}